import type {
  IListReportsParams,
  IListReportsResponse,
  ReportableContentType,
  IModeratorDeletePostParams,
  IModeratorDeleteCommentParams,
} from '$utils/interfaces/moderation';
import { BaseService } from './utils/BaseService';

export class ModService extends BaseService {
  createReport(
    contentType: ReportableContentType,
    contentId: number,
    reason: string,
  ) {
    return this.client.send('/api/moderation/report', {
      method: 'POST',
      body: { contentType, contentId, reason },
    });
  }

  createBugReport(description: string) {
    return this.client.send('/api/moderation/bug', {
      method: 'POST',
      body: { description },
    });
  }

  listReports(query?: IListReportsParams): Promise<IListReportsResponse> {
    return this.client.send('/api/moderation/reports', {
      method: 'GET',
      query,
    });
  }
  moderatorDeletePost(query?: IModeratorDeletePostParams) {
    return this.client.send('/api/moderation/post', {
      method: 'DELETE',
      query,
    });
  }
  // TODO update to match the backend when the backend is ready
  moderatorDeleteComment(query?: IModeratorDeleteCommentParams) {
    return this.client.send('/api/moderation/comment', {
      method: 'DELETE',
      query,
    });
  }
}
